const PRODUCT_IMAGES_BUCKET = 'products';
const SUPABASE_PROJECT_URL = import.meta.env.VITE_SUPABASE_URL;

export const resolveStoreImageUrl = (path) => {
    if (!path) return null;
    const rawPath = String(path).trim();
    if (!rawPath || rawPath.startsWith('blob:')) return null;
    if (rawPath.startsWith('data:') || /^https?:\/\//i.test(rawPath)) return rawPath;
    if (rawPath.startsWith('/img/') || rawPath.startsWith('img/')) {
        return rawPath.startsWith('/') ? rawPath : `/${rawPath}`;
    }
    if (rawPath.startsWith('/storage/') && SUPABASE_PROJECT_URL) {
        return `${SUPABASE_PROJECT_URL}${rawPath}`;
    }
    if (!SUPABASE_PROJECT_URL) return rawPath;

    const cleanPath = rawPath.replace(/^\/+/, '');
    return `${SUPABASE_PROJECT_URL}/storage/v1/object/public/${PRODUCT_IMAGES_BUCKET}/${cleanPath}`;
};

/**
 * Transformación en el servidor de Supabase: APAGADA por defecto.
 *
 * Ese endpoint se cobra por imagen ORIGEN distinta transformada en el ciclo
 * (100 incluidas en el plan Pro) y llegamos a 680, lo que puso la organización
 * en "exceeding usage limits". Desde que las fotos se achican al subirlas
 * (src/utils/imageResize.js) ya vienen en 640px y transformarlas otra vez es
 * gasto puro.
 *
 * Se deja el interruptor porque las fotos cargadas ANTES de ese cambio siguen
 * pesando lo que pesaban: si alguna tienda vieja se ve lenta, poner
 * VITE_STORE_IMAGE_TRANSFORM=on la vuelve a optimizar, a cambio de volver a
 * consumir cuota. La solución de fondo es re-subir esas fotos.
 */
const TRANSFORMACION_HABILITADA =
    String(import.meta.env.VITE_STORE_IMAGE_TRANSFORM || '').toLowerCase() === 'on';

export const getOptimizedStoreImageUrl = (path, { width = 640, quality = 72 } = {}) => {
    const imageUrl = resolveStoreImageUrl(path);
    if (!imageUrl || imageUrl.startsWith('data:')) return imageUrl;
    if (!TRANSFORMACION_HABILITADA) return imageUrl;
    if (!imageUrl.includes('/storage/v1/object/public/')) return imageUrl;

    const [baseUrl] = imageUrl.split(/[?#]/);
    const renderUrl = baseUrl.replace('/storage/v1/object/public/', '/storage/v1/render/image/public/');
    const params = new URLSearchParams({
        width: String(width),
        quality: String(quality),
        resize: 'cover',
    });

    return `${renderUrl}?${params.toString()}`;
};

export const fallbackToOriginalImage = (event) => {
    const originalSrc = event.currentTarget.dataset.originalSrc;
    if (!originalSrc || event.currentTarget.src === originalSrc) return;
    event.currentTarget.src = originalSrc;
};
